<div fxLayout="column" style="padding:15px;" fxLayoutAlign="center center center">
    <mat-card ngStyle.gt-lg="width:90%;" ngStyle.lg="width:95%;" ngStyle.lt-lg="width:100%;">
        <mat-card-title>
            <app-page-header [title]="'AI Δημιουργός Δηλώσεων'" action=""></app-page-header>
        </mat-card-title>
        <mat-card-content fxLayout="column">
            <mat-horizontal-stepper linear #stepper>
                <!-- Βήμα 1: Δημιουργία με AI -->
                <mat-step [completed]="!isLoading">
                    <ng-template matStepLabel>Δημιουργία με AI</ng-template>

                    <div fxLayout="row" fxLayoutAlign="start center" style="margin: 15px 0;">
                        <mat-icon style="color: var(--primary); margin-right: 10px;">info</mat-icon>
                        <span style="font-family: 'Century Gothic', sans-serif; color: #666;">
                            Χρησιμοποιήστε το AI για να δημιουργήσετε τη δήλωσή σας. Όταν ολοκληρωθεί, πατήστε το κουμπί αντιγραφής (πάνω δεξιά στο AI) και μετά "Επόμενο".
                        </span>
                    </div>

                    <div *ngIf="isLoading" fxLayout="row" fxLayoutAlign="center center" style="height: 400px;">
                        <mat-spinner diameter="50"></mat-spinner>
                        <span style="margin-left: 15px; font-family: 'Century Gothic', sans-serif;">Φόρτωση AI εργαλείου...</span>
                    </div>

                    <iframe
                        [src]="gradioUrl"
                        width="100%"
                        height="750px"
                        frameborder="0"
                        allow="clipboard-write; clipboard-read"
                        [style.display]="isLoading ? 'none' : 'block'"
                        (load)="onIframeLoad()"
                        style="border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.1);">
                    </iframe>

                    <div fxLayout="row" fxLayoutAlign="end center" style="margin-top: 20px;">
                        <button mat-raised-button color="primary" matStepperNext [disabled]="isLoading">
                            Επόμενο
                            <mat-icon style="margin-left: 5px;">arrow_forward</mat-icon>
                        </button>
                    </div>
                </mat-step>

                <!-- Βήμα 2: Μεταφορά στον Form Creator -->
                <mat-step>
                    <ng-template matStepLabel>Μεταφορά στον Form Creator</ng-template>

                    <div fxLayout="column" style="margin-top: 20px; padding: 20px; background: #f8f9fa; border-radius: 8px; border: 1px solid #e0e0e0;">
                        <div fxLayout="row" fxLayoutAlign="start center" style="margin-bottom: 10px;">
                            <mat-icon style="color: #7c3aed; margin-right: 10px;">content_paste</mat-icon>
                            <span style="font-family: 'Century Gothic', sans-serif; font-weight: bold; font-size: 16px;">
                                Επικόλληση κειμένου
                            </span>
                        </div>
                        <span style="font-family: 'Century Gothic', sans-serif; color: #666; margin-bottom: 15px;">
                            Επικολλήστε (Ctrl+V) το κείμενο που αντιγράψατε από το AI:
                        </span>
                        <mat-form-field style="width: 100%;" appearance="outline">
                            <mat-label>Κείμενο δήλωσης από AI</mat-label>
                            <textarea matInput [(ngModel)]="aiText" rows="10" placeholder="Επικολλήστε εδώ το κείμενο που δημιούργησε το AI..."></textarea>
                        </mat-form-field>
                        <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-top: 15px;">
                            <button mat-raised-button matStepperPrevious>
                                <mat-icon style="margin-right: 5px;">arrow_back</mat-icon>
                                Πίσω
                            </button>
                            <button mat-raised-button
                                    [disabled]="!aiText || aiText.trim().length === 0"
                                    style="background-color: #7c3aed; color: white; font-family: 'Century Gothic', sans-serif;"
                                    (click)="transferToFormCreator()">
                                <mat-icon style="margin-right: 5px;">send</mat-icon>
                                Μεταφορά στον Form Creator
                            </button>
                        </div>
                    </div>
                </mat-step>
            </mat-horizontal-stepper>
        </mat-card-content>
    </mat-card>
</div>
